import { render, staticRenderFns } from "./combinedashboard.vue?vue&type=template&id=23852370"
import script from "./combinedashboard.vue?vue&type=script&lang=js"
export * from "./combinedashboard.vue?vue&type=script&lang=js"
import style0 from "./combinedashboard.vue?vue&type=style&index=0&id=23852370&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports